import React from "react";
import { useTranslation } from "react-i18next";
import { Body2 } from "@activecollab/components";
import PropTypes from "prop-types";

const FastSpringPaymentMethodInfo = ({ paymentMethod }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-grid tw-grid-cols-[200px_auto] tw-grid-rows-2 tw-gap-2">
      <Body2
        color="primary"
        weight="bold"
      >
        {t("Payment Type")}
      </Body2>
      <Body2
        color="tertiary"
        data-testid="cardType"
      >
        {paymentMethod.card_type}
      </Body2>
      <Body2
        color="primary"
        weight="bold"
      >
        {t("Payment Gateway")}
      </Body2>
      <Body2 color="tertiary">FastSpring</Body2>
    </div>
  );
};

FastSpringPaymentMethodInfo.propTypes = {
  paymentMethod: PropTypes.object.isRequired,
};

export default FastSpringPaymentMethodInfo;
